import { ButtonProps } from 'common/ui/Button';
import { ReportStatuses } from 'domains/reporter/Reporter/state';
import { unreachableCaseError } from 'types';
import { SubmitType, VariantToStatusMapType } from 'domains/reporter/Reporter/Fields/types';

export const getButtonVariant = ({
  status,
  variantByStatus,
  isInFinalCountdownState = false,
  submitType,
}: {
  status: ReportStatuses;
  variantByStatus?: VariantToStatusMapType;
  isInFinalCountdownState: boolean;
  submitType: SubmitType;
}): ButtonProps['variant'] => {
  if (variantByStatus?.primary.includes(status)) {
    if (submitType === SubmitType.Prelim) {
      return 'ghost';
    }
    return 'primary';
  }
  if (variantByStatus?.yellow.includes(status)) {
    return isInFinalCountdownState ? 'error' : 'yellow';
  }
  if (variantByStatus?.secondary.includes(status)) {
    return 'secondary';
  }
  // If the status does not match any known variants, throw an error
  // This is a safeguard to ensure that all cases are handled
  // and helps catch any future changes to the ReportStatus enum.
  // This should never happen if the enum is used correctly.
  // If you reach this point, it means the status is not recognized.
  // This is a safeguard to ensure that all cases are handled
  return unreachableCaseError(status);
};
